import gql from "graphql-tag";

export const CrawlInfoQuery = gql`
  query CrawlInfoQuery($url: String!, $query: String) {
    crawlInfo(url: $url, query: $query)
  }
`;
